import React from 'react';
import { useSelector } from 'react-redux';

// @ts-ignore
import SchemaAttributeName from 'components/SchemaAttributeName';
import { AppState } from 'services/types';

import { makeSelectIsMultipleAssessments } from '../../selectors';

interface Props {
    schemaAttributeId: number;
    documentSetId: number; // eslint-disable-line
}

export default function JobAttributeLabel(props: Props): React.ReactElement {
    const { schemaAttributeId } = props;
    const isMultipleAssessments = useSelector((state: AppState) =>
        makeSelectIsMultipleAssessments()(state, props)
    );

    return (
        <React.Fragment>
            <SchemaAttributeName schemaAttributeId={schemaAttributeId} />
            {isMultipleAssessments ? ' avg.' : ''}
        </React.Fragment>
    );
}
